import * as React from "react";
import styled from "styled-components";
import i18n from "i18n";
import { useTranslation } from "react-i18next";
import { Input, Row, Col } from "components/bootstrap";
import { FormikInput } from "components/common";
const StyledUl = styled.ul`
  list-style-type: circle;
`;
export const PASSWORD_MIN_LENGTH = 16;
export const validateCloudPasswords = (errors, password, passwordRepeat) => {
  const newErrors = { ...errors };
  const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/;
  if (password && password.length < PASSWORD_MIN_LENGTH) {
    newErrors.password = i18n.t("cloud_password_form_group.password_too_short", {
      ns: "enterprise_authentication",
      length: PASSWORD_MIN_LENGTH
    });
  }
  if (!pattern.test(password)) {
    newErrors.password = i18n.t("cloud_password_form_group.requirements_not_met", {
      ns: "enterprise_authentication"
    });
  }
  if (password && passwordRepeat) {
    const passwordMatches = password === passwordRepeat;
    if (!passwordMatches) {
      newErrors.password_repeat = i18n.t("cloud_password_form_group.passwords_do_not_match", {
        ns: "enterprise_authentication"
      });
    }
  }
  return newErrors;
};
const CloudPasswordFormGroup = ({}) => {
  const { t } = useTranslation("enterprise_authentication");
  const passwordHelp = () => /* @__PURE__ */ React.createElement(React.Fragment, null, t("cloud_password_form_group.requirements_title"), /* @__PURE__ */ React.createElement(StyledUl, null, /* @__PURE__ */ React.createElement("li", null, t("cloud_password_form_group.minimum_length", { length: PASSWORD_MIN_LENGTH })), /* @__PURE__ */ React.createElement("li", null, t("cloud_password_form_group.lower_case")), /* @__PURE__ */ React.createElement("li", null, t("cloud_password_form_group.upper_case")), /* @__PURE__ */ React.createElement("li", null, t("cloud_password_form_group.number")), /* @__PURE__ */ React.createElement("li", null, t("cloud_password_form_group.username_part"))));
  return /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "password-field",
      label: t("cloud_password_form_group.label"),
      help: passwordHelp(),
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9"
    },
    /* @__PURE__ */ React.createElement(Row, { className: "no-bm" }, /* @__PURE__ */ React.createElement(Col, { sm: 6 }, /* @__PURE__ */ React.createElement(
      FormikInput,
      {
        name: "password",
        id: "password",
        type: "password",
        placeholder: t("cloud_password_form_group.label"),
        required: true,
        formGroupClassName: "form-group no-bm",
        wrapperClassName: "col-xs-12",
        minLength: PASSWORD_MIN_LENGTH
      }
    )), /* @__PURE__ */ React.createElement(Col, { sm: 6 }, /* @__PURE__ */ React.createElement(
      FormikInput,
      {
        name: "password_repeat",
        id: "password_repeat",
        type: "password",
        placeholder: t("cloud_password_form_group.repeat_password"),
        formGroupClassName: "form-group no-bm",
        required: true,
        wrapperClassName: "col-xs-12",
        minLength: PASSWORD_MIN_LENGTH
      }
    )))
  );
};
export default CloudPasswordFormGroup;
